import { useParams } from "@solidjs/router";
import { useToast } from "../../components/MessageBox";
import { useApi, isOk } from "../../api";
import { createSignal, onMount } from "solid-js";
import { ItemEntry } from "../../models/ItemEntry";
import { Show } from "solid-js";
import ItemStackView from "../../components/ItemStackView";
import { fromIdentifier } from "../../services/itemRefAdapters";
import Text from "../../components/Text";
import { useTranslation } from "../../hooks/useTranslation";


export function Item() {

    const params = useParams();
    const toast = useToast();
    const api = useApi();
    const { t } = useTranslation();

    const [curritem, setItem] = createSignal<ItemEntry>();

    async function loadItem() {
        const res = await api.itemEntry.getItemEntry(params.id);
        if (isOk(res.data)) setItem(res.data.value.item as unknown as ItemEntry);
    }

    async function update() {
        const res = await api.itemEntry.putItemEntry(curritem() as never);
        if (isOk(res.data)) toast?.info(t('ITEM_SAVED'));
        else toast?.error(t('ITEM_SAVE_FAILED'));
        await loadItem();
    }

    async function adjust(type: number) {

        let price = 0;

        if (type == 0) {
            price = curritem()?.singlePrice!;
        }
        if (type == 1) {
            price = curritem()?.quaterStackPrice!;
        }
        if (type == 2) {
            price = curritem()?.halfStackPrice!;
        }
        if (type == 3) {
            price = curritem()?.stackPrice!;
        }
        if (type == 4) {
            price = curritem()?.threeStacksPrice!;
        }
        if (type == 5) {
            price = curritem()?.nineStacksPrice!;
        }
        if (type == 6) {
            price = curritem()?.doubleChestPrice!;
        }

        await api.itemEntry.adjustPrice(curritem()!.id, price, type as never);
        await loadItem();
    }

    onMount(loadItem);

    return (
        <div class="dashboard-page">
            <h1><Text val="NEW_ITEM" /></h1>
            <Show when={curritem()} >
                <div class="row">
                    <div>
                        <form class="form" style="width: auto" onSubmit={(e) => e.preventDefault()}>
                        <ItemStackView stack={fromIdentifier(curritem()?.minecraftId || '')} />
                        <span><Text val="MINECRAFT_ID" /></span>
                        <input value={curritem()?.minecraftId} onChange={(x) => {
                            setItem({
                                ...curritem()!,
                                minecraftId: (x.target as HTMLInputElement).value
                            });
                        }} disabled style="color: white" />
                        <div class="row item-price-row" style="gap: 2reM">
                            <div>
                                <h3><Text val="ITEM_SELL" /></h3>
                                <span><Text val="ITEM_SINGLE_PRICE" /></span>
                                <span class="row hcenter">
                                    <i class="fa-solid fa-dollar-sign"></i>
                                    <input class="dark-mode-input" type="text" value={curritem()?.singlePrice ?? 0} onChange={(x) => {
                                        setItem({
                                            ...curritem()!,
                                            singlePrice: Number.parseFloat( (x.target as HTMLInputElement).value)
                                        });
                                    }} />
                                    <button onClick={() => adjust(0)}><Text val="ITEM_ADJUST" /></button>
                                </span>
                                <span><Text val="ITEM_QUARTER_STACK" /></span>
                                <span class="row hcenter">
                                    <i class="fa-solid fa-dollar-sign"></i>
                                    <input class="dark-mode-input" type="text" value={curritem()?.quaterStackPrice} onChange={(x) => {
                                        setItem({
                                            ...curritem()!,
                                            quaterStackPrice: Number.parseFloat( (x.target as HTMLInputElement).value)
                                        });
                                    }} />
                                    <button onClick={() => adjust(1)}><Text val="ITEM_ADJUST" /></button>
                                </span>
                                <span><Text val="ITEM_HALF_STACK" /></span>
                                <span class="row hcenter">
                                    <i class="fa-solid fa-dollar-sign"></i>
                                    <input class="dark-mode-input" type="text" value={curritem()?.halfStackPrice} onChange={(x) => {
                                        setItem({
                                            ...curritem()!,
                                            halfStackPrice: Number.parseFloat( (x.target as HTMLInputElement).value)
                                        });
                                    }} />
                                    <button onClick={() => adjust(2)}><Text val="ITEM_ADJUST" /></button>
                                </span>
                                <span><Text val="ITEM_STACK" /></span>
                                <span class="row hcenter">
                                    <i class="fa-solid fa-dollar-sign"></i>
                                    <input class="dark-mode-input" type="text" value={curritem()?.stackPrice} onChange={(x) => {
                                        setItem({
                                            ...curritem()!,
                                            stackPrice: Number.parseFloat( (x.target as HTMLInputElement).value)
                                        });
                                    }} />
                                    <button onClick={() => adjust(3)}><Text val="ITEM_ADJUST" /></button>
                                </span>
                                <span><Text val="ITEM_3X_STACK" /></span>
                                <span class="row hcenter">
                                    <i class="fa-solid fa-dollar-sign"></i>
                                    <input class="dark-mode-input" type="text" value={curritem()?.threeStacksPrice} onChange={(x) => {
                                        setItem({
                                            ...curritem()!,
                                            threeStacksPrice: Number.parseFloat( (x.target as HTMLInputElement).value)
                                        });
                                    }} />
                                    <button onClick={() => adjust(4)}><Text val="ITEM_ADJUST" /></button>
                                </span>
                                <span><Text val="ITEM_9X_STACK" /></span>
                                <span class="row hcenter">
                                    <i class="fa-solid fa-dollar-sign"></i>
                                    <input class="dark-mode-input" type="text" value={curritem()?.nineStacksPrice} onChange={(x) => {
                                        setItem({
                                            ...curritem()!,
                                            nineStacksPrice: Number.parseFloat( (x.target as HTMLInputElement).value)
                                        });
                                    }} />
                                    <button onClick={() => adjust(5)}><Text val="ITEM_ADJUST" /></button>
                                </span>
                                <span><Text val="ITEM_DK" /></span>
                                <span class="row hcenter">
                                    <i class="fa-solid fa-dollar-sign"></i>
                                    <input class="dark-mode-input" type="text" value={curritem()?.doubleChestPrice} onInput={(x) => {
                                        setItem({
                                            ...curritem()!,
                                            doubleChestPrice: Number.parseFloat( (x.target as HTMLInputElement).value)
                                        });
                                    }} />
                                    <button onClick={() => adjust(6)}><Text val="ITEM_ADJUST" /></button>
                                </span>
                            </div>
                        <div>
                            <h3><Text val="ITEM_BUY" /></h3>
                            <span><Text val="ITEM_BUY_SINGLE" /></span>
                            <span class="row hcenter">
                                <i class="fa-solid fa-dollar-sign"></i>
                                <input class="dark-mode-input" type="text" value={curritem()?.purchasePriceSingle ?? 0} onChange={(x) => {
                                    setItem({
                                        ...curritem()!,
                                        purchasePriceSingle: Number.parseFloat( (x.target as HTMLInputElement).value)
                                    });
                                }} />
                            </span>
                            <span><Text val="ITEM_BUY_64X" /></span>
                            <span class="row hcenter">
                                <i class="fa-solid fa-dollar-sign"></i>
                                <input style="color: white" type="text" value={(curritem()?.purchasePriceSingle ?? 0) * 64} disabled/>
                            </span>
                            <span><Text val="ITEM_BUY_DK" /></span>
                            <span class="row hcenter">
                                <i class="fa-solid fa-dollar-sign"></i>
                                <input style="color: white" type="text" value={(curritem()?.purchasePriceSingle ?? 0) * 64 * 54} disabled/>
                            </span>
                            </div>
                        </div>
                        <button onClick={update}><Text val="SAVE" /></button>
                    </form>
                    </div>
                </div>
            </Show>
        </div>
    );
}